import { GenericBaseParameter } from "../base-parameter";

export interface IDemandProposalModel {
  AgreementDate?: string;
  Architecture?: string;
  AutomaticIndex?: boolean;
  BaseRent?: number;
  Bathrooms?: number;
  Bedrooms?: number;
  BoxNr?: string;
  Building?: string;
  BuildingId?: number;
  BuyerReference?: string;
  C21Transaction?: number;
  CadastralIncome?: number;
  Century21Object?: number;
  Charges?: string;
  ChargesOwner?: number;
  ChargesOwnerT?: string;
  ChargesRenter?: number;
  CityName?: string;
  CityPostcode?: string;
  CO2Emission?: number;
  Color?: string;
  CommercialArchives?: number;
  CommercialOffices?: number;
  CommercialShowroom?: number;
  CommercialWarehouse?: number;
  ConditionDesc?: string;
  ConditionId?: number;
  Construction?: number;
  ContractEnd?: string;
  ContractStart?: string;
  ContractType?: string;
  ContractTypeId?: number;
  CreatedDate?: string;
  CZaamCode?: string;
  DescA?: string;
  Desc?: string;
  Elevel?: number;
  EnergyPerformance?: number;
  Environment?: string;
  EPCLabelDesc?: string;
  EPCLabelId?: number;
  ExteriorParkings?: number;
  Floor?: number;
  FreeAvailable?: string;
  FreeAvailableId?: number;
  Garages?: number;
  GeographicAbbr?: string;
  GoogleX?: number;
  GoogleY?: number;
  GroundPart?: number;
  HasAnnex?: boolean;
  HasBoard?: boolean;
  HasFurbished?: boolean;
  HasKey?: boolean;
  HasTerrace?: boolean;
  Id?: number;
  ImageName?: string;
  ImmoPortalCode?: string;
  ImmoPortalTypeOfProperty?: string;
  ImmoWebCode?: string;
  ImmoWebScore?: string;
  ImmoWebTypeOfProperty?: string;
  ImmozoCode?: string;
  ImmozoTypeOfProperty?: string;
  InteriorParkings?: number;
  InvoiceDate?: string;
  InvoiceNumber?: string;
  InvoicePaidDate?: string;
  IsVAT?: boolean;
  KeyDesc?: string;
  LastIndex?: number;
  LayoutType?: number;
  ListingAgent?: string;
  LivingArea?: number;
  LogicImmoCode?: string;
  LogicImmoTypeOfProperty?: string;
  ManagerShortName?: string;
  Map?: string;
  MonthOfSigning?: number;
  MonthOfStartRent?: number;
  ParentGenerationId?: number;
  ParentObjectId?: number;
  PersonRelationComment?: string;
  PersonRelationTypeId?: number;
  PersonRelationTypeName?: string;
  PicCount?: number;
  Price?: number;
  PriceSM?: number;
  ProjectId?: number;
  ProjectName?: string;
  Proprietor?: string;
  PurchaseYear?: number;
  PurposeDesc?: string;
  PurposeId?: number;
  RealCommission?: number;
  ReasonForSelling?: string;
  ReceivedCancellation?: string;
  Record?: string;
  Reference?: string;
  ReferenceSearch?: string;
  RegistrationType?: number;
  RentalSignatureDate?: string;
  RenterReference?: string;
  Rooms?: number;
  RoomsExt?: number;
  SalePrice?: number;
  Share?: number;
  Showerrooms?: number;
  SignerShortName?: string;
  SiteId?: number;
  SiteName?: string;
  StartPrice?: number;
  StartRent?: string;
  StatusDesc?: string;
  StatusId?: number;
  StoryComment?: string;
  Street?: string;
  StreetNumber?: string;
  SubStatusDate?: string;
  SubStatusDesc?: string;
  SubStatusId?: number;
  SurfaceArea?: number;
  TerraceArea?: number;
  TotalArea?: number;
  TypeId?: number;
  TypeOfBuilding?: string;
  UniqueCode?: string;
  UsageAbbr?: string;
  UserId?: number;
  VariousCosts?: number;
  VisitDuration?: number;
  VisitingHours?: string;
  VlanCode?: string;
  VlanTypeOfProperty?: string;
}
export class DemandProposalModel extends GenericBaseParameter<IDemandProposalModel> implements IDemandProposalModel 
{
  AgreementDate: string;
  Architecture: string;
  AutomaticIndex: boolean;
  BaseRent: number;
  Bathrooms: number;
  Bedrooms: number;
  BoxNr: string;
  Building: string;
  BuildingId: number;
  BuyerReference: string;
  C21Transaction: number;
  CadastralIncome: number;
  Century21Object: number;
  Charges: string;
  ChargesOwner: number;
  ChargesOwnerT: string;
  ChargesRenter: number;
  CityName: string;
  CityPostcode: string;
  CO2Emission: number;
  Color: string;
  CommercialArchives: number;
  CommercialOffices: number;
  CommercialShowroom: number;
  CommercialWarehouse: number;
  ConditionDesc: string;
  ConditionId: number;
  Construction: number;
  ContractEnd: string;
  ContractStart: string;
  ContractType: string;
  ContractTypeId: number;
  CreatedDate: string;
  CZaamCode: string;
  DescA: string;
  Desc: string;
  Elevel: number;
  EnergyPerformance: number;
  Environment: string;
  EPCLabelDesc?: string;
  EPCLabelId?: number;
  ExteriorParkings: number;
  Floor: number;
  FreeAvailable: string;
  FreeAvailableId: number;
  Garages: number;
  GeographicAbbr: string;
  GoogleX: number;
  GoogleY: number;
  GroundPart: number;
  HasAnnex: boolean;
  HasBoard: boolean;
  HasFurbished: boolean;
  HasKey: boolean;
  HasTerrace: boolean;
  Id: number;
  ImageName: string;
  ImmoPortalCode: string;
  ImmoPortalTypeOfProperty: string;
  ImmoWebCode: string;
  ImmoWebScore: string;
  ImmoWebTypeOfProperty: string;
  ImmozoCode: string;
  ImmozoTypeOfProperty: string;
  InteriorParkings: number;
  InvoiceDate: string;
  InvoiceNumber: string;
  InvoicePaidDate: string;
  IsVAT: boolean;
  KeyDesc: string;
  LastIndex: number;
  LayoutType: number;
  ListingAgent: string;
  LivingArea: number;
  LogicImmoCode: string;
  LogicImmoTypeOfProperty: string;
  ManagerShortName: string;
  Map: string;
  MonthOfSigning: number;
  MonthOfStartRent: number;
  ParentGenerationId: number;
  ParentObjectId: number;
  PersonRelationComment: string;
  PersonRelationTypeId: number;
  PersonRelationTypeName: string;
  PicCount: number;
  Price: number;
  PriceSM: number;
  ProjectId: number;
  ProjectName: string;
  Proprietor: string;
  PurchaseYear: number;
  PurposeDesc: string;
  PurposeId: number;
  RealCommission: number;
  ReasonForSelling: string;
  ReceivedCancellation: string;
  Record: string;
  Reference: string;
  ReferenceSearch: string;
  RegistrationType: number;
  RentalSignatureDate: string;
  RenterReference: string;
  Rooms: number;
  RoomsExt: number;
  SalePrice: number;
  Share: number;
  Showerrooms: number;
  SignerShortName: string;
  SiteId: number;
  SiteName: string;
  StartPrice: number;
  StartRent: string;
  StatusDesc: string;
  StatusId: number;
  StoryComment: string;
  Street: string;
  StreetNumber: string;
  SubStatusDate: string;
  SubStatusDesc: string;
  SubStatusId: number;
  SurfaceArea: number;
  TerraceArea: number;
  TotalArea: number;
  TypeId: number;
  TypeOfBuilding: string;
  UniqueCode: string;
  UsageAbbr: string;
  UserId: number;
  VariousCosts: number;
  VisitDuration: number;
  VisitingHours: string;
  VlanCode: string;
  VlanTypeOfProperty: string;

  /**
   *
   */
  constructor(option: IDemandProposalModel) {
    super();
    Object.keys(option).forEach(key => this[key] = option[key]);
  }
}